const EmptyRouterView = () => /* webpackChunkName: "EmptyRouterView" */ import("./../views/someArchive/EmptyRouterView.vue");
const SomeArchiveHome = () => /* webpackChunkName: "Home" */ import("./../views/someArchive/Home.vue");
const ArchiveRequest = () => /* webpackChunkName: "ArchiveRequestHome" */ import("./../views/archive/archive_request/ArchiveRequestHome.vue");
const Archive = () => /* webpackChunkName: "Archive" */ import("./../views/archive/archive/Archive.vue");
const PatientHome = () => /* webpackChunkName: "Patienthome" */ import("./../views/archive/patient/PatientHome.vue");
const Caratula = () => /* webpackChunkName: "caratulaInvoice" */ import("./../components/archive/caratulaInvoice.vue");
const Document = () => /* webpackChunkName: "Document" */ import("@/views/general/Document.vue");

export const routes = [
  {
    path: "/someArchive",
    component: EmptyRouterView,
    children: [
      {
        path: "",
        name: "someArchiveHome",
        component: SomeArchiveHome,
      },
      {
        path: "gestor-pacientes",
        name: "someArchivePatientHome",
        component: PatientHome,
      },
      {
        path: "solicitud-archivo",
        name: "archiveArchiveRequest",
        component: ArchiveRequest,
      },
      {
        path: "archivo",
        name: "someArchiveArchive",
        component: Archive,
      },
      {
        path: "caratula/:id",
        name: "caratula-arcivo-html",
        component: Caratula,
      },
      {
        path: "documentacion",
        name: "someArchiveDocumentation",
        component: Document,
      },
    ],
  },
];
